<template>
  <div class="recover">
    <div class="container">
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <el-card show type="primary">
            <h2>Recover Your License</h2>
            <p>
              Lost your PTDefender license? No problem, enter the email you originally used to complete your purchase and we will re-send it.
            </p>
            <el-form>
              <el-input v-model="email" @keyup.enter="submit" type="text" placeholder="john@doe.com">
                <template slot="prepend">Email</template>
              </el-input>
              <hr>
              <el-row type="flex" justify="end">
                <el-button @click="recover" type="primary" :loading="loading" :disabled="!email || loading">
                  Recover License
                </el-button>
              </el-row>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from '@/lib/api'

export default {
  name: 'Recover',
  data() {
    return {
      email: null,
      loading: false
    }
  },
  methods: {
    async recover(event) {
      if (event) event.preventDefault()
      this.loading = true
      try {
        await api.recover({ email: this.email.trim().toLowerCase() })
        await this.$alert('Check your inbox for an email containing your PTDefender license.', 'Email Sent')
      } catch(err) {
        await this.$alert('We could not find a license associated with this email address.', 'Invalid License')
      }
      this.email = null
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.recover {
  padding: 150px 8px 200px 8px;

  .btn-primary {
    color: #fff !important;
    width: 100%;
  }

  .btn {
    text-transform: none;
    border: none;
    padding: 10px;
  }
}
</style>
